<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-lists-page">
    <tl-header></tl-header>
    <div class="wrapper-content-lists-page">
      <span class="title-lists-page">{{'GENERAL.lists' | translate}}</span>
      <div class="wrapper-lists-content">
        <div [routerLink]="PAGES_AND_PATHS.myLists.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'CREATE_NEW_LIST.my_lists' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <div [routerLink]="PAGES_AND_PATHS.favoriteLists.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LISTS.favorite_lists' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <div [routerLink]="PAGES_AND_PATHS.favoriteItems.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LISTS.favorite_items' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <div [routerLink]="PAGES_AND_PATHS.favoriteListers.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LISTS.favorite_listers' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <div [routerLink]="PAGES_AND_PATHS.followedListers.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LISTS.followed_listers' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <div [routerLink]="PAGES_AND_PATHS.recommendedLists.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LISTS.recommended_lists' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <div [routerLink]="PAGES_AND_PATHS.recommendedListers.pagePath" class="wrapper-list-item">
          <div class="image-name-item">
            <img src="../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{'LISTS.recommended_listers' | translate}}
            </span>
          </div>
          <img class="icon-right" src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</div>